module.exports = __webpack_public_path__ + "img/logo.97cb12a3.svg";